import { ComponentRule } from './ComponentRule';
import ComponentForm from './ComponentForm';
import ComponentRuleExecutor from './ComponentRuleExecutor';

class ComponentField {
  private readonly rules: ComponentRule[];

  private dirty: boolean = false;
  private value: any = null;

  constructor(rules: ComponentRule[] = []) {
    this.rules = rules;
  }

  public async onChange(value: any): Promise<void> {
    this.value = value;
    this.dirty = true;
    await this.validate();
  }

  public isDirty(): boolean {
    return this.dirty;
  }

  public getRules(): ComponentRule[] {
    return this.rules;
  }

  public validate(): Promise<ComponentRule[]> {
    return ComponentRuleExecutor.execute(this, this.value);
  }

  public reset() {
    this.dirty = false;
    this.value = null;
  }
}

export default ComponentField;
